// extracted by mini-css-extract-plugin
module.exports = {"container":"AverageRating_container__K8KnT","ratingText":"AverageRating_ratingText__ZC_s_"};